<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <DeployedTable ref="deployedTable"></DeployedTable>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import DeployedTable from '../../../components/deploymentManagement/deployedInstance/DeployedTable';

export default {
  name: 'DeployedInstance',
  components: {
    DeployedTable,
    BasicLayout,
  },
  data() {
    return {
      neid: null,
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: '一级菜单/已部署服务实例'
      },
    };
  },
  methods: {

  },
  mounted() {
    // this.$refs.deployedTable.getDeployedGrid();
    console.log('==========', this.$refs.deployedTable.$refs.grid);
    this.$refs.deployedTable.$refs.grid.init(0);
  }
};
</script>

<style scoped>

</style>
